import moment from 'moment';
import uuid from 'uuid';

import { api } from 'redux/api/index.api';
import { getProjectsServiceVersion } from 'utils/constants';

export const companiesApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchCompanies: builder.query({
      query: ({ projectId, searchValue, limit, offset }) => ({
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/filter`,
        method: 'POST',
        params: {
          limit,
          offset,
        },
        body: {
          search_term: searchValue,
        },
      }),
      providesTags: ['Companies'],
    }),
    fetchCompany: builder.query({
      query: ({ projectId, companyId }) => ({
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/${companyId}`,
        method: 'GET',
      }),
    }),
    addCompanies: builder.mutation({
      query: ({ projectId, names }) => ({
        method: 'POST',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/create-bulk`,
        body: {
          companies: names.map(name => ({
            id: uuid.v4(),
            name,
            client_created_at: moment(),
          })),
        },
      }),
      invalidatesTags: ['Companies'],
    }),
    deleteCompanies: builder.mutation({
      query: ({ projectId, ids }) => ({
        method: 'POST',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/delete-bulk`,
        body: {
          company_ids: ids,
        },
      }),
      invalidatesTags: ['Companies'],
    }),
    editCompany: builder.mutation({
      query: ({ projectId, companyId, name, reference }) => ({
        method: 'PUT',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/${companyId}/`,
        body: {
          name,
          reference,
          client_created_at: moment(),
        },
      }),
      invalidatesTags: ['Companies'],
    }),
    addMembers: builder.mutation({
      query: ({ projectId, members, companyId }) => ({
        method: 'POST',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/${companyId}/add-members`,
        body: {
          user_ids: members,
        },
      }),
      invalidatesTags: ['Companies'],
    }),
    removeMembers: builder.mutation({
      query: ({ projectId, members, companyId }) => ({
        method: 'POST',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/${companyId}/remove-members`,
        body: {
          user_ids: members,
        },
      }),
      invalidatesTags: ['Companies'],
    }),
    importCompanies: builder.mutation({
      query: ({ projectId, data64 }) => ({
        method: 'POST',
        url: `${getProjectsServiceVersion()}/projects/${projectId}/companies/excel-bulk`,
        body: {
          data: data64,
        },
      }),
      invalidatesTags: ['Companies'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchCompaniesQuery,
  useFetchCompanyQuery,
  useLazyFetchCompanyQuery,
  useAddCompaniesMutation,
  useDeleteCompaniesMutation,
  useAddMembersMutation,
  useRemoveMembersMutation,
  useEditCompanyMutation,
  useImportCompaniesMutation,
} = companiesApi;
